import { render, staticRenderFns } from "./zlfList.vue?vue&type=template&id=940bcd92&scoped=true"
import script from "./zlfList.vue?vue&type=script&lang=js"
export * from "./zlfList.vue?vue&type=script&lang=js"
import style0 from "./zlfList.vue?vue&type=style&index=0&id=940bcd92&prod&lang=css"
import style1 from "./zlfList.vue?vue&type=style&index=1&id=940bcd92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940bcd92",
  null
  
)

export default component.exports